module.exports = __webpack_public_path__ + "static/vwtext-regularitalic-6210fd12029e255de506e082424cf9b4.woff2";